import { Payload, Props } from 'recharts/types/component/DefaultLegendContent';
import { Box, List, ListItem, Text, Flex } from 'quotient';
import styled from 'styled-components';

type LegendColorProps = {
  itemColor?: string;
};

const LegendColor = styled.div<LegendColorProps>`
  width: 16px;
  height: 16px;

  background-color: ${({ itemColor }) => itemColor || '#9CA3AF'};
  border-radius: 2px;
`;

export function Legend(props: Props) {
  const { payload } = props;
  if (!payload) {
    return <></>;
  }
  return (
    <Box>
      <List spacing={1}>
        {payload.map((p: Payload) => {
          return (
            <ListItem key={p.value}>
              <Flex alignItems="center" gap={2} justifyContent="left">
                <LegendColor itemColor={p.color} />
                <Text display="inline">{`${p.value}`}</Text>
              </Flex>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
}
